import ClientProfilePage from './ClientProfilePage';
export default ClientProfilePage;
